import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = ["for"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Checkbox = _resolveComponent("Checkbox")!

  return (_ctx.filter.choices)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("h4", null, _toDisplayString(_ctx.filter.label), 1),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filter.choices, (choice) => {
          return (_openBlock(), _createElementBlock("div", {
            key: choice.id,
            class: "p-field-checkbox"
          }, [
            _createVNode(_component_Checkbox, {
              id: _ctx.filter.name + '-' + choice.id,
              value: choice.id,
              modelValue: _ctx.selected,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selected) = $event)),
              disabled: _ctx.loading
            }, null, 8, ["id", "value", "modelValue", "disabled"]),
            _createElementVNode("label", {
              for: _ctx.filter.name + '-' + choice.id
            }, _toDisplayString(choice.label), 9, _hoisted_2)
          ]))
        }), 128))
      ]))
    : _createCommentVNode("", true)
}